import { useState } from "react";

export const useCategoryState = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [categoryID, setCategoryId] = useState<string>();
  const [cartId, setCartId] = useState<string | null>(null);
  const [modal, setModal] = useState(false);

  const resetCategoryState = () => {
    setSearchQuery("");
    setCategoryId("");
    setCartId("");
    setModal(false);
  };

  return {
    searchQuery,
    setSearchQuery,
    categoryID,
    setCategoryId,
    cartId,
    setCartId,
    modal,
    setModal,
    resetCategoryState,
  };
};
